export const STUDIO_URL = 'studio';

export const STUDIO_PRODUCTION_ID_PARAM = 'id';
